import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";
import MarkdownContent from "@/components/MarkdownContent";

// Public, no-auth legal/content page. Renders ONLY the latest published version.
export default function PublicContentPage({ slug: fixedSlug, contentType = "legal" }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [page, setPage] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    let alive = true;
    setPage(undefined);
    axios
      .get(`${API_BASE}/content/public/${contentType}/${slug}`)
      .then((r) => alive && setPage(r.data))
      .catch(() => alive && setPage(null));
    return () => {
      alive = false;
    };
  }, [slug, contentType]);

  return (
    <PublicLayout>
      {page === undefined && (
        <p className="font-mono text-sm text-muted-foreground" data-testid="public-page-loading">
          Loading…
        </p>
      )}
      {page === null && (
        <div data-testid="public-page-notfound">
          <h1 className="font-heading text-3xl font-bold text-foreground">Page not found</h1>
          <p className="text-muted-foreground mt-3">This page is not available.</p>
        </div>
      )}
      {page && (
        <article data-testid={`public-page-${slug}`}>
          <MarkdownContent markdown={page.body} />
          <p className="mt-12 pt-6 border-t border-border text-xs text-muted-foreground font-mono">
            Version {page.version}
            {page.published_at ? ` · Last updated ${new Date(page.published_at).toLocaleDateString()}` : ""}
          </p>
        </article>
      )}
    </PublicLayout>
  );
}
